<template>
	<div ref="summary-section" class="summary-section">
		<div class="title">{{ $t('main.details-tabs.summary') }}</div>
		<!-- eslint-disable-next-line vue/no-v-html -->
		<div class="content" v-html="getLocaleString(game.about)"></div>
	</div>
</template>

<script>
import { getLocaleString } from '../../../plugins/helpers';

export default {
	name: 'GameDetailsSummarySection',
	components: {},
	props: {
		game: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {};
	},
	computed: {
		language() {
			return this.$i18n.locale;
		},
	},
	mounted() {
		this.$emit('setRef', 'summary', this.$refs['summary-section']);
	},
	methods: {
		getLocaleString(data) {
			return getLocaleString(data, this.language);
		},
	},
};
</script>

<style lang="less" scoped>
.summary-section {
	height: 100%;
	padding: 0 20px;
	margin: 50px auto 0;
	user-select: none;
	width: 100%;
	.title {
		color: white;
		font-size: 20px;
		height: 40px;
		letter-spacing: -0.4px;
	}
	.content {
		background-color: #27292c;
		border: 1px solid rgba(255, 255, 255, 0.1);
		border-radius: 5px;
		box-shadow: 0 0 1px 0 #000000;
		color: #7c7c7e;
		font-size: 14px;
		letter-spacing: -0.28px;
		line-height: 26px;
		margin: auto;
		padding: 23px 23px 21px 19px;
		width: auto;
		& ::v-deep {
			strong {
				color: #dddddd;
			}
			p {
				line-height: normal;
				margin: 0;
			}
		}
	}
}

@media (min-width: 768px) {
	.summary-section {
		.content {
			padding: 49px 51px 47px 50px;
		}
	}
}

@media (min-width: 1024px) {
	.summary-section {
		.title {
			font-size: 16px;
			letter-spacing: -0.32px;
			margin: 0 auto;
			padding-top: 5px;
			width: 770px;
		}
		.content {
			font-size: 12px;
			letter-spacing: -0.24px;
			line-height: 18px;
			padding: 31px 36px 35px 35px;
			width: 770px;
		}
	}
}

@media (min-width: 1280px) {
	.summary-section {
		.title {
			width: 960px;
		}
		.content {
			padding: 31px 48px 38px 36px;
			width: 960px;
		}
	}
}

@media (min-width: 1440px) {
	.summary-section {
		display: flex;
		margin: 80px auto 0;
		padding: 0;
		width: 1080px;
		.title {
			color: white;
			font-size: 20px;
			letter-spacing: -0.4px;
			margin: 0;
			width: 250px;
		}
		.content {
			flex: 1;
			font-size: 14px;
			letter-spacing: -0.28px;
			line-height: 24px;
			margin: 0 0 0 20px;
			padding: 49px 51px 47px 50px;
		}
	}
}

@media (min-width: 1600px) {
	.summary-section {
		width: 1200px;
		.title {
			width: 270px;
		}
		.content {
			padding: 49px 53px 47px 50px;
		}
	}
}

@media (min-width: 1920px) {
	.summary-section {
		width: 1440px;
		.title {
			width: 340px;
		}
	}
}
</style>
